import Blue from "~/core";

new Blue({
	name: 'Interior Nav Toggle',
	selector: ".interior-nav__parent-item",
	setup(parentItem) {
		const interiorNav = parentItem.closest(".interior-nav");
		const parentItemList = [...interiorNav.querySelectorAll(".interior-nav__parent-item")];
		const trigger = parentItem.querySelector(".interior-nav__parent-arrow");

		function toggleMenu() {
			if (!parentItem.classList.value.includes("interior-nav__parent-item--active")) {
				parentItemList.forEach(item => item.classList.remove("interior-nav__parent-item--active"));
			} 
			parentItem.classList.toggle("interior-nav__parent-item--active");
		}

		if (trigger) {
			this.$addEvents(trigger, "click.prevent enter.prevent", toggleMenu);
		}
	}
});

new Blue({
	name: 'Interior nav mobile',
	selector: '.interior-nav__go-to',
	setup(mobileBtn) {
		const interiorNav = mobileBtn.closest(".interior-nav");
		const navUl = interiorNav.querySelector(".interior-nav__wrapper");
		function toggleNavMobile() {
			navUl.classList.toggle("interior-nav__wrapper--active");
		}
		this.$addEvents(mobileBtn, "click.prevent enter.prevent", toggleNavMobile);
	}
})
		